import { useMutation } from "@tanstack/react-query";
import { createJobTitle as apiCreate } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateJobTitle() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: createJobTitle, isPending, data: results, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/job-titles');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createJobTitle, results };
}
